import { EscapeHTML } from 'appRoot/scripts/Util';
import { toast } from 'vue3-toastify';

export default function ToasterHelper()
{
	this.error = this.Error = function (title, message, duration)
	{
		if (!duration)
			duration = 30000;
		makeToast('error', title, message, duration);
	};
	this.warning = this.Warning = function (title, message, duration)
	{
		if (!duration)
			duration = 30000;
		makeToast('warning', title, message, duration);
	};
	this.info = this.Info = function (title, message, duration)
	{
		makeToast('info', title, message, duration);
	};
	this.success = this.Success = function (title, message, duration)
	{
		makeToast('success', title, message, duration);
	};
	this.custom = this.Custom = function (options)
	{
		// Make a toast with custom properties.  Options follow the old @deveodk/vue-toastr "add" API
		// and are mapped onto vue3-toastify here:
		//	toaster.custom({
		//		title: 'Heyy', // Toast Title
		//		msg: 'I am a custom property toastr', // Message
		//		timeout: 1000, // Timeout in ms
		//		type: 'info', // Toast type: 'info', 'success', 'warning', 'error'
		//		closeOnHover: true, // Pause the timeout while the mouse is over the toast; default true
		//		clickClose: false, // Close the toast when it is clicked; default false
		//		// Available callbacks
		//		onCreated: () => console.log('toast was created'),
		//		onClicked: () => console.log('toast was clicked'),
		//		onClosed: () => console.log('toast was closed')
		//	})
		let opt = {
			type: options.type ? options.type : 'info',
			dangerouslyHTMLString: true
		};
		if (typeof options.timeout === "number")
			opt.autoClose = options.timeout;
		if (typeof options.closeOnHover === "boolean")
			opt.pauseOnHover = options.closeOnHover;
		if (typeof options.clickClose === "boolean")
			opt.closeOnClick = options.clickClose;
		if (typeof options.onCreated === "function")
			opt.onOpen = options.onCreated;
		if (typeof options.onClicked === "function")
			opt.onClick = options.onClicked;
		if (typeof options.onClosed === "function")
			opt.onClose = options.onClosed;
		toast(buildToastHtml(options.title, options.msg), opt);
	};
	function makeToast(type, title, message, duration)
	{
		if (!duration)
			duration = 10000;
		if (!message)
		{
			message = title;
			title = null;
		}

		if (typeof message === "object")
		{
			let str = "";
			if (typeof message.name === "string")
				str = EscapeHTML(message.name);
			if (typeof message.code === "string")
				str += " (code " + EscapeHTML(message.code) + ")";
			str += ": ";
			if (typeof message.message === "string")
				str += EscapeHTML(message.message);
			else
				str += "[no error message]";
			if (typeof message.stack === "string")
			{
				let stack = message.stack;
				if (stack.startsWith(str))
					stack = stack.substr(str.length);
				str += ": " + EscapeHTML(stack);
			}
			message = str;
			console.error(type + " toast:", message);
		}
		else
		{
			if (type === "error")
				console.error(type + " toast:", message);
			else
				console.log(type + " toast:", message);
			message = EscapeHTML(message.toString());
		}
		toast(buildToastHtml(title, message), {
			type: type,
			autoClose: duration,
			dangerouslyHTMLString: true
		});
	}
	/**
	 * Builds the HTML content of a toast from an optional title and an HTML-escaped message, mimicking the old toastr layout of a bold title line above the message.
	 * @param {String} title Toast title (plain text; will be HTML-escaped). May be null or empty.
	 * @param {String} message Toast message (already HTML-escaped by the caller).
	 * @returns {String} HTML string for the toast content.
	 */
	function buildToastHtml(title, message)
	{
		if (title)
			return "<strong>" + EscapeHTML(title.toString()) + "</strong><br>" + message;
		return message;
	}
}
